module.exports = __webpack_public_path__ + "static/media/conclusion.ba26f7e8.mp3";